import { CardTypeEnum, PaymentCardStateEnum } from '.spec/self-care/tsTypes';

import { Currency } from '@skippay/core/@types/currency';
import { HintedString } from '@skippay/core/utils/types';

/* eslint-disable camelcase */
export enum GA_VERSION {
	V3,
	V4,
}

export type GAEventData = {
	eAct?: string;
	eCat: string;
	eInt?: boolean;
	eLab?: string;
	eVal?: number;
	gaVersion?: GA_VERSION;
};

export type GAEvent = {
	event: 'gaEvent';
	eventCallback: () => void;
	gaEventData: GAEventData;
};

export type EcommerceItem =
	| {
			promotion_id: HintedString<'affil_coupon' | 'affil_promo'>;
			promotion_name?: string;
			creative_name?: string;
			creative_slot?: string;
			location_id?: string;
			user_id?: string;
	  }
	| {
			item_id: string;
			item_name: string;
			item_brand: string;
			item_category: HintedString<'insurance'>;
			item_variant?: string;
			price: number;
			quantity: number;
	  }
	| {
			promotion_id: HintedString<'paygate_xsell' | 'billing_part_payment' | 'magic_link_xsell'>;
			promotion_name: string;
			creative_name: HintedString<'checkout_tile' | 'magic_link_tile'>;
			creative_slot: string;
			location_id: string;
	  }
	| {
			promotion_id: 'card_activation';
			item_state: PaymentCardStateEnum;
			item_id: string;
			item_type: CardTypeEnum;
	  };

type Ecommerce = {
	ecommerce?: {
		currency?: Currency;
		payment_type?: string;
		value?: number;
		items: EcommerceItem[];
	};
};

export type GA4Event = {
	event: string;
	ecommerce?: Ecommerce['ecommerce'];
	[key: string]: string | number | boolean | Ecommerce['ecommerce'];
};

type GAPageviewBase = {
	gaVersion?: GA_VERSION;
};

export type GAPageviewData = GAPageviewBase & {
	pTitle: string;
	pUrl?: string;
	pHostname?: string;
};

export type GAPageview = GAPageviewData & {
	event: 'gaPageview';
	pHostname: string;
};

export type GA4Pageview = GAPageviewBase & {
	event: string;
	// eslint-disable-next-line camelcase
	page_location?: string;
	// eslint-disable-next-line camelcase
	page_title?: string;

	[key: string]: string | number | boolean | undefined;
};

declare global {
	interface Window {
		dataLayer: Array<GAEvent | GA4Event | GAPageview | GA4Pageview | { gaEventData: undefined }>;
	}
}
